
import _ from 'lodash';
export const TYPES =
    {
        /*PROFILE*/ // eslint-disable-line
        // ATLAS: {
        //     id: 'ATLAS',
        //     inputType: 'PROFILE',
        //     display: 'ToolBeltData Profile',
        //     description: 'A profile source type for all internal profiling activities',
        // },
        ASSOCIATION: {
            id: 'ASSOCIATION',
            inputType: 'PROFILE',
            display: 'Association',
            description: 'A profile source type for company associations or affiliations',
        },
        MANUFACTURER: {
            id: 'MANUFACTURER',
            inputType: 'PROFILE',
            display: 'Manufacturer',
            description: 'A profile source type for manufacturer profiles (eg find-a-dealer)',
        },
        ONLINE: {
            id: 'ONLINE',
            inputType: 'PROFILE',   
            display: 'Online',
            description: 'A profile source type for online profiles (eg google) not otherwise typed',
        },
        PLACE: {
            id: 'PLACE',
            inputType: 'PROFILE',
            display: 'Place',
            description: 'A profile source type for places',
        },
        SUPPLIER: {
            id: 'SUPPLIER',
            inputType: 'PROFILE',
            display: 'Supplier',
            description: 'A profile source type for supplier',
        },
        THIRD_PARTY: {
            id: 'THIRD_PARTY',
            inputType: 'PROFILE',
            display: 'Third Party',
            description: 'A profile source type for third party profiles',
        },
        TRADE_PUBLICATION: {
            id: 'TRADE_PUBLICATION',
            inputType: 'PROFILE',
            display: 'Trade Publication',
            description: 'A profile source type for trade publications',
        },
        UTILITY: {
            id: 'UTILITY',
            inputType: 'PROFILE',
            display: 'Utility',
            description: 'A profile source type for utility profiles (eg trade partners, contractor locators)',
        },
        /*END PROFILE*/ // eslint-disable-line
        LICENSOR: {
            id: 'LICENSOR',
            inputType: 'LICENSE',
            display: 'Licensor',
            description: 'A source type for licensors',
        },
        PERMITTING_AUTHORITY: {
            id: 'PERMITTING_AUTHORITY',
            inputType: 'PERMIT',
            display: 'Permitting Authority',
            description: 'A source type for permitting authorities',
        },
        POLICY_PROVIDER: {
            id: 'POLICY_PROVIDER',
            inputType: 'POLICY',
            display: 'Policy Provider',
            description: 'A source type for policy providers',
        },
        REGISTRAR: {
            id: 'REGISTRAR',
            inputType: 'REGISTRATION',
            display: 'Registrar',
            description: 'A source type for registrars',
        },
    }

    export function getTypeById(id) {
        if (id) {
            return _.get(TYPES, id);
        }
    }
